import React from "react";
import { Quote } from "lucide-react";
import Section from "@/theme/Section";
import { useContent } from "@/lib/content";

const ACCENTS = ["#c8ff2a", "#ff2a8f", "#2ad6ff"];

const Testimonials = () => {
  const { sections } = useContent();
  const s = sections.testimonials || {};
  const items = (s.items || []).filter((i) => i.enabled);
  if (!s.enabled || items.length === 0) return null;
  return (
    <Section
      id="testimonials"
      testid="testimonials-section"
      eyebrow="Client Love"
      title='What clients <span style="color:#ff2a8f">say</span>'
      subtitle="Real notes from studios we&apos;ve shipped for."
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((t, i) => {
          const accent = ACCENTS[i % ACCENTS.length];
          return (
            <article
              key={t.id}
              data-testid={`testimonial-${i}`}
              className="p-7 flex flex-col gap-6 transition-transform hover:-translate-y-1"
              style={{
                background: "rgba(13,13,13,0.7)",
                border: "1px solid rgba(255,255,255,0.12)",
                backdropFilter: "blur(14px)",
                borderRadius: "24px",
              }}
            >
              <Quote size={28} strokeWidth={1.6} style={{ color: accent }} />
              <p
                className="text-[15px] leading-relaxed"
                style={{ color: "rgba(255,255,255,0.85)" }}
              >
                {t.text}
              </p>
              <div className="mt-auto pt-4 flex items-center gap-3 border-t border-white/10">
                {t.clientImage && (
                  <img
                    src={t.clientImage}
                    alt={t.clientName}
                    className="w-11 h-11 rounded-full object-cover"
                    style={{ border: `2px solid ${accent}` }}
                  />
                )}
                <div>
                  <div
                    className="font-black text-sm uppercase"
                    style={{
                      fontFamily: "'Azeret Mono', monospace",
                      letterSpacing: "-0.02em",
                      color: "#fff",
                    }}
                  >
                    {t.clientName}
                  </div>
                  <div className="text-[10px] tracking-[0.22em] uppercase mt-0.5 text-white/55">
                    {t.clientTitle}
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </Section>
  );
};

export default Testimonials;
